import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const ModuleMenu = styled.div`
    ${BaseStyle.Mixins.gaps.large};
    background: ${({ theme }) => theme.Surface.primary};
    display: flex;
`;

export default ModuleMenu;
